module.exports = __webpack_public_path__ + "img/nodata.023c9c7f.png";